import React from 'react'

interface IDay {
  dayName: string | null
  from: string | null
  to: string | null
}

interface OpeningHoursProps {
  days: readonly (IDay | null)[]
}

export const OpeningHours = ({ days }: OpeningHoursProps) => {
  return (
    <ul className="w-full">
      {days &&
        days.length &&
        days.map((day) => {
          if (!day) return null

          const { dayName, from, to } = day

          return (
            <li key={dayName} className="flex justify-between">
              <span>{dayName}</span>
              <span className="tabular-nums">
                {from}—{to}
              </span>
            </li>
          )
        })}
    </ul>
  )
}
